import React from 'react'
import { Route, IndexRoute } from 'react-router'
import * as Views from './views'
import Layout from './Layout'

const Routes = (
  <Route path="styleguide" component={ Layout }>
    <IndexRoute component={ Views.Styleguide }/>
  </Route>
)

export default Routes
